// extracted by mini-css-extract-plugin
export default {"tableHead":"style_tableHead__ZCJfV","stickyHeader":"style_stickyHeader__j1ZoZ"};